<template lang="pug">
.w-btn-play-pause
  transition( name='fade-superfast' mode='out-in' )
    w-btn-icon(
      :key='action'
      v-bind=`{ size, noHover }`
      @click.prevent='togglePause'
    )
      component( :is='icon' :title='title' )
</template>

<script lang="js">
import WBtnIcon from './w-btn-icon'
import IPlay from 'icons/Play'
import IPause from 'icons/Pause'

export default {
  name: 'PlayPauseButtonWidget',
  mixins: [],
  components: { WBtnIcon, IPlay, IPause },
  props: {
    paused: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'lg'
    },
    noHover: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {
    togglePause() {
      this.$emit( this.action )
    },
  },
  computed: {
    action() {
      return this.paused ? 'play' : 'pause'
    },
    icon() {
      return `i-${ this.action }`
    },
    title() {
      return this.paused ? 'Play' : 'Pause'
    },
  }
}
</script>

<style lang="scss">
.w-btn-play-pause {

}
</style>
